function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { customPropTypes, doesNodeContainClick, makeDebugger, useAutoControlledValue, useEventCallback } from '../lib';
import useTrigger from './utils/useTrigger';
import PortalInner from './PortalInner';
var debug = makeDebugger('portal');

/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */
function Portal(props) {
  var children = props.children,
    _props$closeOnDocumen = props.closeOnDocumentClick,
    closeOnDocumentClick = _props$closeOnDocumen === void 0 ? true : _props$closeOnDocumen,
    _props$closeOnEscape = props.closeOnEscape,
    closeOnEscape = _props$closeOnEscape === void 0 ? true : _props$closeOnEscape,
    closeOnPortalMouseLeave = props.closeOnPortalMouseLeave,
    closeOnTriggerBlur = props.closeOnTriggerBlur,
    closeOnTriggerClick = props.closeOnTriggerClick,
    closeOnTriggerMouseLeave = props.closeOnTriggerMouseLeave,
    mountNode = props.mountNode,
    mouseEnterDelay = props.mouseEnterDelay,
    mouseLeaveDelay = props.mouseLeaveDelay,
    _props$openOnTriggerC = props.openOnTriggerClick,
    openOnTriggerClick = _props$openOnTriggerC === void 0 ? true : _props$openOnTriggerC,
    openOnTriggerFocus = props.openOnTriggerFocus,
    openOnTriggerMouseEnter = props.openOnTriggerMouseEnter,
    _props$hideOnScroll = props.hideOnScroll,
    hideOnScroll = _props$hideOnScroll === void 0 ? false : _props$hideOnScroll;
  var _useAutoControlledVal = useAutoControlledValue({
      state: props.open,
      defaultState: props.defaultOpen,
      initialState: false
    }),
    _useAutoControlledVal2 = _slicedToArray(_useAutoControlledVal, 2),
    open = _useAutoControlledVal2[0],
    setOpen = _useAutoControlledVal2[1];
  var contentRef = React.useRef();
  var _useTrigger = useTrigger(props.trigger, props.triggerRef),
    _useTrigger2 = _slicedToArray(_useTrigger, 2),
    triggerRef = _useTrigger2[0],
    trigger = _useTrigger2[1];
  var mouseEnterTimer = React.useRef();
  var mouseLeaveTimer = React.useRef();
  var latestDocumentMouseDownEvent = React.useRef();

  // ----------------------------------------
  // Behavior
  // ----------------------------------------

  var openPortal = function openPortal(e) {
    debug('open()');
    setOpen(true);
    _.invoke(props, 'onOpen', e, _objectSpread(_objectSpread({}, props), {}, {
      open: true
    }));
  };
  var openPortalWithTimeout = function openPortalWithTimeout(e, delay) {
    debug('openWithTimeout()', delay);
    // React wipes the entire event object and suggests using e.persist() if
    // you need the event for async access. However, even with e.persist
    // certain required props (e.g. currentTarget) are null so we're forced to clone.
    var eventClone = _objectSpread({}, e);
    return setTimeout(function () {
      return openPortal(eventClone);
    }, delay || 0);
  };
  var closePortal = useEventCallback(function (e) {
    debug('close()');
    setOpen(false);
    _.invoke(props, 'onClose', e, _objectSpread(_objectSpread({}, props), {}, {
      open: false
    }));
  });
  var closePortalWithTimeout = function closePortalWithTimeout(e, delay) {
    debug('closeWithTimeout()', delay);
    // React wipes the entire event object and suggests using e.persist() if
    // you need the event for async access. However, even with e.persist
    // certain required props (e.g. currentTarget) are null so we're forced to clone.
    var eventClone = _objectSpread({}, e);
    return setTimeout(function () {
      return closePortal(eventClone);
    }, delay || 0);
  };

  // ----------------------------------------
  // Document Event Handlers
  // ----------------------------------------

  React.useEffect(function () {
    // Clean up timers
    clearTimeout(mouseEnterTimer.current);
    clearTimeout(mouseLeaveTimer.current);
  }, []);
  var handleDocumentMouseDown = useEventCallback(function (e) {
    latestDocumentMouseDownEvent.current = e;
  });
  var handleDocumentClick = useEventCallback(function (e) {
    var _contentRef$current;
    var currentMouseDownEvent = latestDocumentMouseDownEvent.current;
    latestDocumentMouseDownEvent.current = null;

    // event happened in trigger (delegate to trigger handlers)
    var isInsideTrigger = doesNodeContainClick(triggerRef.current, e);
    // event originated in the portal but was ended outside
    var isOriginatedFromPortal = currentMouseDownEvent && doesNodeContainClick(contentRef.current, currentMouseDownEvent);
    // event happened in the portal
    var isInsidePortal = doesNodeContainClick(contentRef.current, e);
    if (!((_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.contains) ||
    // no portal
    isInsideTrigger || isOriginatedFromPortal || isInsidePortal) {
      return;
    } // ignore the click

    if (closeOnDocumentClick) {
      debug('handleDocumentClick()');
      closePortal(e);
    }
  });
  var handleEscape = useEventCallback(function (e) {
    if (!closeOnEscape) {
      return;
    }
    if (e.key !== 'Escape') {
      return;
    }
    debug('handleEscape()');
    closePortal(e);
  });

  // ----------------------------------------
  // Component Event Handlers
  // ----------------------------------------

  React.useEffect(function () {
    if (!hideOnScroll) {
      return;
    }
    var handleScroll = function handleScroll(e) {
      debug('handleHideOnScroll()');

      // Do not hide the popup when scroll comes from inside the popup
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/4305
      if (_.isElement(e.target) && contentRef.current.contains(e.target)) {
        return;
      }
      closePortal(e);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [closePortal, hideOnScroll]);
  var handlePortalMouseLeave = useEventCallback(function (e) {
    if (!closeOnPortalMouseLeave) {
      return;
    }

    // Do not close the portal when 'mouseleave' is triggered by children
    if (e.target !== contentRef.current) {
      return;
    }
    debug('handlePortalMouseLeave()');
    mouseLeaveTimer.current = closePortalWithTimeout(e, mouseLeaveDelay);
  });
  var handlePortalMouseEnter = useEventCallback(function () {
    // In order to enable mousing from the trigger to the portal, we need to
    // clear the mouseleave timer that was set when leaving the trigger.
    if (!closeOnPortalMouseLeave) {
      return;
    }
    debug('handlePortalMouseEnter()');
    clearTimeout(mouseLeaveTimer.current);
  });
  var handleTriggerBlur = function handleTriggerBlur(e) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    // Call original event handler
    _.invoke.apply(_, [trigger, 'props.onBlur', e].concat(rest));

    // IE 11 doesn't work with relatedTarget in blur events
    var target = e.relatedTarget || document.activeElement;
    // do not close if focus is given to the portal
    var didFocusPortal = _.invoke(contentRef.current, 'contains', target);
    if (!closeOnTriggerBlur || didFocusPortal) {
      return;
    }
    debug('handleTriggerBlur()');
    closePortal(e);
  };
  var handleTriggerClick = function handleTriggerClick(e) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    // Call original event handler
    _.invoke.apply(_, [trigger, 'props.onClick', e].concat(rest));
    if (open && closeOnTriggerClick) {
      debug('handleTriggerClick() - close');
      closePortal(e);
    } else if (!open && openOnTriggerClick) {
      debug('handleTriggerClick() - open');
      openPortal(e);
    }
  };
  var handleTriggerFocus = function handleTriggerFocus(e) {
    for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      rest[_key3 - 1] = arguments[_key3];
    }
    // Call original event handler
    _.invoke.apply(_, [trigger, 'props.onFocus', e].concat(rest));
    if (!openOnTriggerFocus) {
      return;
    }
    debug('handleTriggerFocus()');
    openPortal(e);
  };
  var handleTriggerMouseLeave = function handleTriggerMouseLeave(e) {
    clearTimeout(mouseEnterTimer.current);

    // Call original event handler
    for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      rest[_key4 - 1] = arguments[_key4];
    }
    _.invoke.apply(_, [trigger, 'props.onMouseLeave', e].concat(rest));
    if (!closeOnTriggerMouseLeave) {
      return;
    }
    debug('handleTriggerMouseLeave()');
    mouseLeaveTimer.current = closePortalWithTimeout(e, mouseLeaveDelay);
  };
  var handleTriggerMouseEnter = function handleTriggerMouseEnter(e) {
    clearTimeout(mouseLeaveTimer.current);

    // Call original event handler
    for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      rest[_key5 - 1] = arguments[_key5];
    }
    _.invoke.apply(_, [trigger, 'props.onMouseEnter', e].concat(rest));
    if (!openOnTriggerMouseEnter) {
      return;
    }
    debug('handleTriggerMouseEnter()');
    mouseEnterTimer.current = openPortalWithTimeout(e, mouseEnterDelay);
  };
  React.useEffect(function () {
    if (!open) return;
    var portalNode = contentRef.current;
    document.addEventListener('mousedown', handleDocumentMouseDown);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleEscape);
    if (portalNode) {
      portalNode.addEventListener('mouseleave', handlePortalMouseLeave);
      portalNode.addEventListener('mouseenter', handlePortalMouseEnter);
    }
    return function () {
      document.removeEventListener('mousedown', handleDocumentMouseDown);
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keydown', handleEscape);
      if (portalNode) {
        portalNode.removeEventListener('mouseleave', handlePortalMouseLeave);
        portalNode.removeEventListener('mouseenter', handlePortalMouseEnter);
      }
    };
  }, [open, handleDocumentMouseDown, handleDocumentClick, handleEscape, handlePortalMouseLeave, handlePortalMouseEnter]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(PortalInner, {
    mountNode: mountNode,
    onMount: function onMount() {
      return _.invoke(props, 'onMount', null, props);
    },
    onUnmount: function onUnmount() {
      return _.invoke(props, 'onUnmount', null, props);
    },
    ref: contentRef
  }, children), trigger && /*#__PURE__*/React.cloneElement(trigger, {
    onBlur: handleTriggerBlur,
    onClick: handleTriggerClick,
    onFocus: handleTriggerFocus,
    onMouseLeave: handleTriggerMouseLeave,
    onMouseEnter: handleTriggerMouseEnter,
    ref: triggerRef
  }));
}
Portal.displayName = 'Portal';
Portal.propTypes = {
  /** Primary content. */
  children: PropTypes.node.isRequired,
  /** Controls whether or not the portal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,
  /** Controls whether or not the portal should close when escape is pressed is displayed. */
  closeOnEscape: PropTypes.bool,
  /**
   * Controls whether or not the portal should close when mousing out of the portal.
   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
   * gap from the trigger to the portal.
   */
  closeOnPortalMouseLeave: PropTypes.bool,
  /** Controls whether or not the portal should close on blur of the trigger. */
  closeOnTriggerBlur: PropTypes.bool,
  /** Controls whether or not the portal should close on click of the trigger. */
  closeOnTriggerClick: PropTypes.bool,
  /** Controls whether or not the portal should close when mousing out of the trigger. */
  closeOnTriggerMouseLeave: PropTypes.bool,
  /** Initial value of open. */
  defaultOpen: PropTypes.bool,
  /** Hide the Popup when scrolling the window. */
  hideOnScroll: PropTypes.bool,
  /** The node where the portal should mount. */
  mountNode: PropTypes.any,
  /** Milliseconds to wait before opening on mouse over */
  mouseEnterDelay: PropTypes.number,
  /** Milliseconds to wait before closing on mouse leave */
  mouseLeaveDelay: PropTypes.number,
  /**
   * Called when a close event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,
  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,
  /**
   * Called when an open event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,
  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,
  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,
  /** Controls whether or not the portal should open when the trigger is clicked. */
  openOnTriggerClick: PropTypes.bool,
  /** Controls whether or not the portal should open on focus of the trigger. */
  openOnTriggerFocus: PropTypes.bool,
  /** Controls whether or not the portal should open when mousing over the trigger. */
  openOnTriggerMouseEnter: PropTypes.bool,
  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node,
  /** Called with a ref to the trigger node. */
  triggerRef: customPropTypes.ref
};
Portal.Inner = PortalInner;
export default Portal;
//# sourceMappingURL=Portal.js.map